import React from "react";
import { Trash2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { inputClass, btnGhost } from "@/components/Brand";

/** Type-to-confirm deletion, used for both a single gallery and a batch. */
export const DeleteProjectDialog = ({ title, text, onText, onConfirm, onClose }) => {
  const { t } = useI18n();

  return (
    <div className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center px-5">
      <div data-testid="delete-project-modal" className="w-full max-w-md border border-[#8B0000]/40 bg-[#0F0F0F] p-8 fade-up">
        <p className="eyebrow text-[#8B0000]">{t("delete_project")}</p>
        <h2 className="mt-3 text-2xl tracking-tight">{title}</h2>
        <p className="mt-4 text-sm text-[#A8A8A8] leading-relaxed">{t("delete_warning")}</p>
        <input data-testid="delete-confirm-input" value={text} onChange={(e) => onText(e.target.value)}
          placeholder="HAPUS" className={`${inputClass} mt-6`} />
        <div className="mt-6 flex flex-wrap gap-3">
          <button data-testid="delete-confirm-btn" disabled={text.trim().toUpperCase() !== "HAPUS"}
            onClick={onConfirm}
            className="inline-flex items-center gap-2 bg-[#8B0000] text-white px-5 py-3 text-[10px] tracking-[0.18em] uppercase font-semibold disabled:opacity-30">
            <Trash2 size={13} /> {t("delete_project")}
          </button>
          <button data-testid="delete-cancel-btn" onClick={onClose} className={btnGhost}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};
